<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage" id="epi01">
<div class="epigraph">
<p class="epigraphText"><em class="italic">Men say I am a saint losing himself in politics. The fact is that I am a politician trying my hardest to become a saint</em>.</p>
<p class="epigraphSource">Mahatma Gandhi</p>
</div>
<div class="epigraph">
<p class="epigraphText"><em class="italic">Saints should always be judged guilty until they are proved innocent.</em></p>
<p class="epigraphSource">George Orwell</p>
</div>
<div class="epigraph">
<p class="epigraphText"><em class="italic">In wrath the Liberator shall descend into Thargland. The gods shall nee before him; they shall bow their heads before him, they will spread their hands before his feet.</em></p>
<p class="epigraphSource"><em class="italic">Filoby Testament, 1001</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// futureindefinite_epi01.vue?5a993158